let baseAppProxy = "https://console-shopify.ringbuilder.io";

async function refreshSwatchEvents() {
    if (!HackWrapper.isEmpty(HackWrapper.getElements('.variant-swatches-item-selected'))) {
        HackWrapper.getElements('.variant-swatches-item-selected').forEach(element => {
            element.addEventListener('click', async function(){
                const _this = this, _parentElement = _this.parentElement, productHandle =  this.parentElement.dataset.handle;
                if (this?.dataset?.type == 'Metal Type') {
                    HackWrapper.getElements(`[data-collection-variant-metal="${productHandle}"] > li`).forEach(e => e.classList.remove('active'));
                } else if (this?.dataset?.type == 'Stone Shape') {
                    HackWrapper.getElements(`[data-collection-variant-shapes="${productHandle}"] > li`).forEach(e => e.classList.remove('active'));
                }
                this.classList.toggle('active');

                let groupId = '', attributeInfo = {};
                HackWrapper.getElements(`.collections-variant-swatches-selector[data-product-handle="${productHandle}"] > ul > li.active`).forEach(function (item) {
                    attributeInfo[item.dataset.type] = item.dataset.value;
                    groupId = item.dataset.groupId;
                });

                try {
                    var formData = new FormData();
                    formData.append("action", "fetch_sub_options");
                    formData.append("shop", Shopify.shop);
                    formData.append("group_id", groupId.trim());
                    formData.append("attribute_info", JSON.stringify(attributeInfo));

                    const attrInfo = await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
                    if (attrInfo?.status === "success") {
                        const prodInfoData = attrInfo?.data?.product_data;
                        const queryString = window.location.search;
                        const collection_path = location.pathname;

                        HackWrapper.getElements(`[data-card-title="${productHandle}"]`).forEach(e => e.innerHTML = prodInfoData?.prod_title);
                        HackWrapper.getElements(`[data-card-link="${productHandle}"]`).forEach(e => e.setAttribute('href', `${collection_path}/products/${prodInfoData?.pro_handle}${queryString}`));
                        HackWrapper.getElements(`[data-card-price="${productHandle}"]`).forEach(e => e.innerHTML = HackWrapper.formatMoney(HackWrapper.convertToShopCurrency(Number(prodInfoData?.price) * 100)) + ' Setting Price');

                        const images = prodInfoData?.images.split(',') ?? [];
                        HackWrapper.getElements(`[data-card-image="${productHandle}"]`).forEach(e => e.setAttribute('src', images[0] ?? ""));
                        HackWrapper.getElements(`[data-card-image-hover="${productHandle}"]`).forEach(e => e.setAttribute('src', images[1] ?? ""));
                    } else {
                        console.log("Data not found based on attribute");
                    }
                } catch (error) {
                    console.log({error});
                }
            });
        });
    }
}

async function onLoadSwatchCollectionSelected() {
    let products = [];
    HackWrapper.getElements('.custom_swatches.collections-variant-swatches-selector').forEach(function (element) {
        !HackWrapper.isEmpty(element?.dataset?.productHandle) && (products.push(element?.dataset?.productHandle));
    });
    
    if (!HackWrapper.isEmpty(products)) {
        try {
            var formData = new FormData();
            formData.append("action", "fetch_product_options_multiple");
            formData.append("shop", Shopify.shop);
            formData.append("handles", products.toString());

            const collectionProdInfo = await HackWrapper.fetchData(`${baseAppProxy}/frontend.php`, formData, "POST");
            if (collectionProdInfo?.status === "success") {
                const collectionProdInfoData = collectionProdInfo?.data?.products ?? {};
                if (!HackWrapper.isEmpty(collectionProdInfoData)) {
                    const collectionKeys = Object.keys(collectionProdInfoData);
                    collectionKeys.forEach(function (key) {
                        const collectionProducts = collectionProdInfoData[key];
                        if (!HackWrapper.isEmpty(collectionProducts?.option_data)) {
                            let optionData = collectionProducts?.option_data.reverse(), collectionProdInfoHtml = "";
                            optionData.map(function (option) {
                                const subArray = Object.values(option?.values)?.length > 0 ? Object.values(option?.values) : array();
                                if (option?.label == "Metal Type") {
                                    const variantMetalOptionHtml = subArray.map((item) => {
                                        let metalColorValue = item.replace(/14k|18k|14K|18K|Gold|gold/g, "").trim();
                                        let selectedMetal = option?.selected.replace(/14k|18k|14K|18K|Gold|gold/g, "").trim();
                                        if (!item.includes('18K')) {
                                            return `<li class="variant-swatches-item-selected color common-swatch ${HackWrapper.handleize(metalColorValue.toLowerCase())}-gold${selectedMetal == metalColorValue ? ` active`: ""}" data-group-id="${collectionProducts?.product_data?.group_id}" data-type="${option?.label}" data-value="${item}"></li>`;
                                        }
                                    }).join("");
                                    collectionProdInfoHtml += `<ul class="colors" data-handle="${key}" data-collection-variant-metal="${key}">${variantMetalOptionHtml}</ul>`;
                                } else if (option?.label == "Stone Shape") {
                                    const variantShapeOptionHtml = subArray.map((item) => {
                                        return `<li class="variant-swatches-item-selected shape-item custom-filter--item${option?.selected == item ? ` active`: ""}" data-group-id="${collectionProducts?.product_data?.group_id}" data-type="${option?.label}" data-value="${item}">
                                            <img src="https://cdn.shopify.com/s/files/1/0686/8995/3069/files/${HackWrapper.handleize(item)}.png?v=1" alt="${item}">
                                        </li>`;
                                    }).join("");
                                    collectionProdInfoHtml += `<ul class="setting-stones" data-handle="${key}" data-collection-variant-shapes="${key}">${variantShapeOptionHtml}</ul>`;
                                }
                            });
                            const collectionProdInfoElement = HackWrapper.getElement(`.custom_swatches.collections-variant-swatches-selector[data-product-handle="${key}"]`);
                            collectionProducts?.length > 7 && (collectionProdInfoElement.classList.add('variant-swatches--list-overflow'));
                            collectionProdInfoElement.innerHTML = collectionProdInfoHtml;

                            const containers_ss = document.querySelectorAll(".setting-stones");
                            if(containers_ss && containers_ss.length>0){
                                containers_ss.forEach(container => {
                                    const activeItem = container.querySelector(".active");
                                    if (activeItem) {
                                        // --- OR if you want precise manual centering ---
                                        container.scrollLeft = activeItem.offsetLeft - container.offsetWidth / 2 + activeItem.offsetWidth / 2;
                                    }
                                });
                            }
                            

                        }
                    });
                }
            }
        } catch (error) {
            console.log({error});
        }
        refreshSwatchEvents();
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    await onLoadSwatchCollectionSelected();
});
